(() => {
  'use strict';
  const el = document.querySelector('[data-bbb-witch]');
  if (!el || el.dataset.ready) return;
  el.dataset.ready = 'true';
  const image = el.querySelector('img');
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const key = 'bbb-halloween-flight-v1';
  let timer = 0, animation = null, loading = false, generation = 0, pageCount = 0;
  const blocked = () => document.hidden || motion.matches ||
    document.querySelector('dialog[open],.drawer--is-open,.modal--is-active,.rps-overlay-open') ||
    document.documentElement.classList.contains('bbb-menu-lock') ||
    /INPUT|TEXTAREA|SELECT/.test(document.activeElement?.tagName || '');
  function state() {
    try {
      const saved = JSON.parse(sessionStorage.getItem(key) || 'null');
      return saved && Date.now() - saved.last < 1800000 ? saved : { count: 0, last: 0 };
    } catch (_) { return { count: 3, last: Date.now() }; }
  }
  function hide() {
    generation++;
    loading = false;
    image.onload = image.onerror = null;
    if (animation) { animation.onfinish = null; animation.cancel(); animation = null; }
    el.style.visibility = 'hidden';
  }
  function schedule(delay) {
    clearTimeout(timer);
    if (!motion.matches && pageCount < 2 && state().count < 3) timer = setTimeout(fly, delay);
  }
  function fly() {
    timer = 0;
    const saved = state();
    if (saved.count >= 3 || pageCount >= 2 || motion.matches) return;
    if (blocked() || scrollY < 120 || Date.now() - saved.last < 60000) { schedule(10000); return; }
    if (loading || animation) return;
    const direction = Math.random() < .5 ? 'left' : 'right';
    const boosted = Math.random() < .55;
    const boostImage = boosted ? new Image() : null;
    if (boostImage) boostImage.src = el.dataset[direction + 'Boost'];
    const token = ++generation;
    loading = true;
    image.onload = () => {
      if (token !== generation) return;
      image.onload = null;
      loading = false;
      if (blocked()) { schedule(10000); return; }
      const width = el.offsetWidth, height = el.offsetHeight;
      const header = document.getElementById('SiteHeader')?.getBoundingClientRect();
      const minY = Math.max(110, (header?.bottom || 0) + 20);
      const maxY = innerHeight - height - 100;
      if (maxY < minY + 35) { schedule(15000); return; }
      const y = minY + Math.random() * (maxY - minY);
      const amplitude = Math.min(30, (maxY - minY) / 3);
      const phase = Math.random() < .5 ? -1 : 1;
      const from = direction === 'right' ? -width - 20 : innerWidth + 20;
      const to = direction === 'right' ? innerWidth + 20 : -width - 20;
      const frames = Array.from({ length: 9 }, (_, i) => {
        const p = i / 8;
        const top = Math.max(minY, Math.min(maxY, y + Math.sin(p * Math.PI * 2) * amplitude * phase));
        return { transform: 'translate3d(' + (from + (to - from) * p) + 'px,' + top + 'px,0)', offset: p };
      });
      try { sessionStorage.setItem(key, JSON.stringify({ count: saved.count + 1, last: Date.now() })); }
      catch (_) { return; }
      pageCount++;
      el.style.visibility = 'visible';
      const finish = () => { hide(); schedule(65000 + Math.random() * 30000); };
      if (!boosted) {
        animation = el.animate(frames, { duration: 4800, easing: 'linear', fill: 'both' });
        animation.onfinish = finish;
        return;
      }
      const midpoint = .46 + Math.random() * .08;
      const x = from + (to - from) * midpoint;
      const approach = Array.from({ length: 5 }, (_, i) => {
        const p = i / 4;
        return { transform: 'translate3d(' + (from + (x - from) * p) + 'px,' +
          (y + Math.sin(p * Math.PI * 2) * amplitude * phase) + 'px,0) rotate(0deg)', offset: p };
      });
      animation = el.animate(approach, { duration: 2400, easing: 'linear', fill: 'both' });
      animation.onfinish = () => {
        if (token !== generation || blocked()) { finish(); return; }
        const ready = boostImage.complete && boostImage.naturalWidth > 0;
        const horizontal = direction === 'right' ? 1 : -1;
        const vertical = Math.random() < .5 ? -1 : 1;
        const angle = ready ? horizontal * vertical * 45 : 0;
        const distance = Math.max(innerWidth, innerHeight) + width + height;
        const endX = ready ? x + horizontal * distance : to;
        const endY = ready ? y + vertical * distance : y;
        image.onerror = null;
        if (ready) image.src = boostImage.src;
        animation.cancel();
        animation = el.animate([
          { transform: 'translate3d(' + x + 'px,' + y + 'px,0) rotate(0deg)', offset: 0 },
          { transform: 'translate3d(' + (x + (endX - x) * .045) + 'px,' +
            (y + (endY - y) * .045) + 'px,0) rotate(' + angle + 'deg)', offset: .18 },
          { transform: 'translate3d(' + endX + 'px,' + endY + 'px,0) rotate(' + angle + 'deg)', offset: 1 }
        ], { duration: ready ? 1600 : 2400, easing: 'cubic-bezier(.45,0,1,1)', fill: 'both' });
        animation.onfinish = finish;
      };
    };
    image.onerror = () => { loading = false; schedule(30000); };
    image.src = el.dataset[direction];
  }
  document.addEventListener('pointerdown', () => { if (animation || loading) { hide(); schedule(30000); } }, { passive: true });
  document.addEventListener('focusin', () => { if (blocked()) { hide(); schedule(30000); } });
  document.addEventListener('visibilitychange', () => { hide(); clearTimeout(timer); if (!document.hidden) schedule(15000); });
  addEventListener('resize', () => { hide(); schedule(15000); }, { passive: true });
  addEventListener('pagehide', () => { hide(); clearTimeout(timer); });
  addEventListener('pageshow', event => { if (event.persisted) schedule(15000); });
  motion.addEventListener('change', () => { hide(); clearTimeout(timer); if (!motion.matches) schedule(15000); });
  schedule(12000);
})();
